import React from "react";
import InputUI from "@/componentsUI/Input";
import { useTranslationPlus } from "@/Core/i18n/useTranslationPlus";
import styles from "./index.module.less";

interface MobileInputProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
}

const MobileInput: React.FC<MobileInputProps> = ({
  value,
  onChange,
  placeholder,
  disabled = false,
}) => {
  const { t } = useTranslationPlus("Wallet");

  const handleChange = (val: string) => {
    // 只允许输入数字，最多10位
    const numbersOnly = val.replace(/\D/g, "").slice(0, 10);
    onChange?.(numbersOnly);
  };

  const handleClear = () => {
    onChange?.("");
  };

  return (
    <>
      <div className={styles.inputContainer}>
        <InputUI
          className={styles.mobileInput}
          value={value}
          onChange={handleChange}
          placeholder={placeholder || t("Enter mobile number")}
          maxLength={10}
          disabled={disabled}
        />
        {value && !disabled && (
          <button
            type="button"
            className={styles.clearButton}
            onClick={handleClear}
          >
            ×
          </button>
        )}
      </div>
    </>
  );
};

export default MobileInput;
